import { render, staticRenderFns } from "./sideAsyncAdd.vue?vue&type=template&id=38937d21&scoped=true&lang=html"
import script from "./sideAsyncAdd.vue?vue&type=script&lang=js"
export * from "./sideAsyncAdd.vue?vue&type=script&lang=js"
import style0 from "./sideAsyncAdd.vue?vue&type=style&index=0&id=38937d21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38937d21",
  null
  
)

export default component.exports